// Image hébergée par PromoDeep (API /images) : `url` est absolue et utilisable partout (web, mobile, push…)
export interface StoredImage {
  id: string;
  url: string;
  contentType: string;
  size: number;
}

export const MAX_IMAGE_BYTES = 5 * 1024 * 1024;
export const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif', 'image/avif'];
